import BrowseSidebar from './BrowseSidebar';

export default BrowseSidebar;
